import { createSelector } from 'reselect'

export const getOrganizationSettings = state => state.get('organizationSettings')

export const getOrganizationSettingsEntity = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('entity')
)

export const getOrganizationSettingsEntityWelcomeEmailAndLanding = createSelector(
  getOrganizationSettingsEntity,
  orgSettings => orgSettings.get('welcomeEmail')
)

export const getOrganizationSettingsEntityDomain = createSelector(getOrganizationSettingsEntity, orgSettings =>
  orgSettings.get('domain')
)

export const getOrganizationSettingsEntityName = createSelector(getOrganizationSettingsEntity, orgSettings =>
  orgSettings.get('name')
)

export const getOrganizationSettingsPending = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('pending')
)

export const getOrganizationSettingsPendingGet = createSelector(getOrganizationSettingsPending, pending =>
  pending.get('get')
)

export const getOrganizationSettingsPendingByDomain = createSelector(getOrganizationSettingsPending, pending =>
  pending.get('settingsByDomain')
)

export const getPendingPromoPageSettings = createSelector(getOrganizationSettingsPending, pending =>
  pending.get('promoPage')
)

export const getOrganizationSettingsByDomain = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('settingsByDomain')
)

export const getOrganizationSettingsLanguageByDomain = createSelector(getOrganizationSettingsByDomain, orgSettings =>
  orgSettings.get('language')
)

export const getOrganizationSettingsByDomainCountriesCodes = createSelector(
  getOrganizationSettingsByDomain,
  orgSettings => orgSettings.get('countriesCodes')
)

export const getOrganizationSettingsByDomainOrganization = createSelector(
  getOrganizationSettingsByDomain,
  orgSettings => orgSettings.get('organization')
)

export const isSMSAvailableOrganizationSettingsByDomain = createSelector(getOrganizationSettingsByDomain, orgSettings =>
  orgSettings.get('sms')
)

export const getPromoPageSettings = createSelector(getOrganizationSettings, orgSettings => orgSettings.get('promoPage'))

const getSettingByDomain = createSelector(getOrganizationSettings, orgSettings => orgSettings.get('settingsByDomain'))

const getPromoPageSettingsByDomain = createSelector(getSettingByDomain, settingsByDomain =>
  settingsByDomain.get('promoPageSettings')
)

export const isPhoneIsRequiredForOrganization = createSelector(getPromoPageSettingsByDomain, settingsByDomain =>
  settingsByDomain.get('phoneIsRequired')
)

export const getOrganizationSettingsChildrenList = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('children')
)
